import React, { useState, useEffect, useCallback } from "react";
import Box from "@material-ui/core/Box";
import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import NmefSpinner from "../../NmefSpinner";
import useAPIError from "../../APIError";
import { ApplicationDataAPI } from "../../API/ApplicationDataAPI";
import NewNote from "./NewNote";
import NoteList from "./NoteList";

const useStyles = makeStyles(() => ({
	paper: {
		minWidth: "calc(25%)",
		maxWidth: "calc(30%)",
		height: "auto",
        top: "65px !important",
	},
}));

const Notes = ({ onClose, anchorEl, app, setCanCloseNotes }) => {
	const classes = useStyles();
	const open = Boolean(anchorEl);
	const id = open ? "notes-popover" : undefined;

	const { addError } = useAPIError();
	const [reload, setReload] = useState(true);
	const [isDeleteProgress, setIsDeleteProgress] = useState({
		status: false,
		id: "",
	});
	const [notes, setNotes] = useState([]);

	const fetchNotes = useCallback(
		(appId) => {
			(async () => {
				try {
					const response = await ApplicationDataAPI.fetchApplicationNotesById(
						appId,
						"All",
						app.locked_by_email
					);
					const sortedNotes = response?.sort(function (a, b) {
						return new Date(b.created_date) - new Date(a.created_date);
					});
					setNotes(sortedNotes);
				} catch (error) {
					addError(error);
				} finally {
					setReload(false);
				}
			})();
		},
		[addError]
	);
	useEffect(() => {
		(async () => {
			if (app?.id && reload) {
				fetchNotes(app?.id);
			}
		})();
	}, [app?.id, reload]);

	const onNoteSaved = async () => {
		setReload(true);
	};

	const handleDelete = async (data) => {
		try {
			if (isDeleteProgress?.status) return;
			setIsDeleteProgress({ status: true, id: data.id });
			const updatedNote = { ...data, invalidated_datetime: new Date() };
			await ApplicationDataAPI.updateNote(updatedNote, app?.broker_id, app.locked_by_email);
		} catch (error) {
			addError(error);
		} finally {
			onNoteSaved(data);
			setIsDeleteProgress({ status: false, id: "" });
		}
	};

	return (
		<Popover
			id={id}
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "center",
			}}
			classes={{ paper: classes.paper }}
			transformOrigin={{
				vertical: "top",
				horizontal: "center",
			}}>
			<Box sx={{ padding: "15px" }}>
				<Box sx={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
					<Typography variant="h5">Notes</Typography>
				</Box>
				<NewNote app={app} onNoteSaved={onNoteSaved} setCanCloseNotes={setCanCloseNotes} />
				<hr />
				{reload ? (
					<NmefSpinner />
				) : (
					<NoteList
						notes={notes}
						handleDelete={handleDelete}
						isDeleteProgress={isDeleteProgress}
					/>
				)}
			</Box>
		</Popover>
	);
};

export default Notes;
